import { TimingObject } from "../common/timing.object";

export class ShopPortalOrderResponse {
    OrderNumberShopPortal: number;
    OrderNumberWholesaler: number;
    AdditionalOrderNumbersWholesaler: number[];
    PdfUrl: string;
    ErrorMessage: string;
    Timing: TimingObject;
}